module.exports = __webpack_public_path__ + "static/media/doors.7e47496e.jpg";